module.exports = {};



//////////////////
// WEBPACK FOOTER
// ./cfg/slot-config.js
// module id = 25
// module chunks = 0